import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/compras/compras';
import Compras from './ComprasFormTabs';


const ms2p = (state) => {
  return {
    ...state.compra,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Compras);
